import { atom } from 'jotai';

import type {
  WorkHomePendingView,
  WorkHomeView,
} from '../../contracts/projects/work-home-url';

/** One-shot navigation intent consumed by the Work page before paint. */
export const pendingWorkHomeViewAtom = atom<WorkHomePendingView | null>(null);

/**
 * Mirror of `ProjectsPage`'s current view, published so the chat sidebar can
 * render a persistent active state on its "Workflows" entry. `ProjectsPage`
 * keeps it in sync with its local `view` and resets it to `home` on unmount,
 * so the highlight clears the moment the user leaves the Work home.
 *
 * The guided routine-creation chat publishes `home` here — it is a chat
 * surface, not the Routines split.
 */
export const currentWorkHomeViewAtom = atom<'home' | WorkHomeView>('home');
